import { type Project } from '@/entities/project';
import request from '@/shared/api/request';

export const getDefaultProject = (): Promise<{ project: Project }> =>
  request({
    url: '/projects/default/',
  });
